/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AirtableOrderView.vue?vue&type=template&id=41a4e463"
import script from "./AirtableOrderView.vue?vue&type=script&lang=js"
export * from "./AirtableOrderView.vue?vue&type=script&lang=js"
import style0 from "./AirtableOrderView.vue?vue&type=style&index=0&id=41a4e463&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41a4e463')) {
      api.createRecord('41a4e463', component.options)
    } else {
      api.reload('41a4e463', component.options)
    }
    module.hot.accept("./AirtableOrderView.vue?vue&type=template&id=41a4e463", function () {
      api.rerender('41a4e463', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/infoview/AirtableOrderView.vue"
export default component.exports